import React, { useEffect, useState, useRef } from "react";
import Swal2 from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import "../styles/payments.css";
import Loading from "../helpers/loading_component.js";
import emailjs from "@emailjs/browser";
import LoadingPopup from "../helpers/loading_component.js";
import { secretKey } from "../.././data";
import SelectSearch from "react-select-search";
import Select from "react-select";

const MySwal = withReactContent(Swal2);

const AddClientContact = (props) => {
  const [content, setContent] = useState("");
  const [type, setType] = useState("");
  const [client, setClient] = useState("");
  const [loading, setLoading] = useState(true);
  const [clientId, setClientId] = useState(
    props.mode !== "main" ? +props.clientsData.identifier : ""
  );
  const [clients, setClients] = useState([]);
  const [clientsSygn, setClientsSygn] = useState([]);
  const [clientsOptions, setClientsOptions] = useState([]);

  const fetchClients = async () => {
    if (props.mode === "detail") {
      setLoading(false);
    } else {
      var body = {
        team: props.team,
      };

      await fetch("https://apidevkppp.ftpeople.pl/getClientsListAddDate", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: secretKey,
        },
        body: JSON.stringify(body),
      })
        .then((response) => response.json())
        .then((data) => {
          data = getAllowedClients(data).filter((el) => el.arch === "0");
          setClients(data);
          setClientsOptions(createClientsOptions(data));
          setLoading(false);
        })
        .catch((error) => {});
    }
  };

  const fetchClientsAll = async () => {
    if (props.mode === "detail") {
      setLoading(false);
    } else {
      var body = {
        team: props.team,
      };

      await fetch("https://apidevkppp.ftpeople.pl/getClientsListAddDateAll", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: secretKey,
        },
        body: JSON.stringify(body),
      })
        .then((response) => response.json())
        .then((data) => {
          data = getAllowedClients(data).filter((el) => el.arch === "0");
          setClients(data);
          setClientsOptions(createClientsOptions(data));
          setLoading(false);
        })
        .catch((error) => {});
    }
  };

  const getAllowedClients = (data) => {
    if (props.user.allowedClients === "all") {
      return data;
    } else {
      var allowed = props.user.allowedClients
        .toString()
        .replaceAll(" ", "")
        .split(",");
      var arr = [];
      allowed.map((el) => {
        arr = arr.concat(data.filter((el2) => +el2.id === +el));
      });
      return arr;
    }
  };

  const fetchClientsSygn = async () => {
    var body = {};

    await fetch("https://apidevkppp.ftpeople.pl/getClientsSygn", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {
        setClientsSygn(data);
        setLoading(false);
      })
      .catch((error) => {});
  };

  const getData = () => {
    setLoading(true);
    if (props.team === 0) {
      fetchClientsAll();
    } else {
      fetchClients();
    }

    //fetchClientsSygn();
  };

  useEffect(() => {
    getData();
  }, []);

  const handleContentChange = (e) => {
    setContent(e.target.value);
  };

  const handleTypeChange = (e) => {
    setType(e.target.value);
  };

  const handleClientChange = (e) => {
    setClientId(e.value);
    setClient(e.value);
  };

  const checkIfIdentifierisUniqe = async (id) => {
    var rows = await props.clientsContactSheetData.getRows();
    var arr = rows.filter((el) => el.identifier === id);

    if (arr.length > 0) {
      return false;
    }

    return true;
  };

  const addClientContact = async (e) => {
    if (validatePayment()) {
      setLoading(true);
      var body = {
        type: type,
        content: content.replaceAll("'", ""),
        date: new Date(),
        clientId: props.mode === "main" ? client : props.clientsData.id,
        user: props.user.name,
      };

      await fetch("https://apidevkppp.ftpeople.pl/addClientContact", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: secretKey,
        },
        body: JSON.stringify(body),
      })
        .then((response) => response.json())
        .then((data) => {})
        .catch((error) => {});

      props.logClientAction(
        "Dodano kontakt z klientem",
        props.mode === "main" ? client : props.clientsData.id
      );

      MySwal.fire({
        icon: "success",
        title: "Dodano",
        text: "kontakt z klientem",
      }).then(async (result) => {
        props.close();
      });
    } else {
      MySwal.fire({
        icon: "error",
        title: "Błąd",
        text: "Wypełnij wymagane pola formularza",
      });
    }
  };

  const generateNewIdentifier = (rows) => {
    var lastID = 0;

    var arr = [];
    arr = rows;

    var arrNum = [];
    arr.map((el) => {
      var id = el.id;
      arrNum.push(+id);
    });

    var arrSrt = arrNum.sort((a, b) => {
      return b - a;
    });

    lastID = +arrSrt[0] > 0 ? arrSrt[0] : 1;

    return lastID + 1;
  };

  const validatePayment = (e) => {
    if (content.length > 0 && type.length > 0 && clientId !== "") {
      return true;
    } else {
      return false;
    }
  };

  const getActualSygnForClient = (clientId) => {
    var sygns = clientsSygn.filter((el) => +el.clientId === +clientId);
    sygns.sort(function (a, b) {
      return new Date(b.date) - new Date(a.date);
    });
    return sygns.length > 0
      ? sygns[0].sygn.length > 4
        ? sygns[0].sygn
        : "brak danych"
      : "brak danych";
  };

  const createClientsOptions = (data) => {
    var bankOptions = [];
    data.map((el) => {
      bankOptions.push({
        label:
          el.petitioner +
          " | " +
          (data.filter((el2) => el2.id === el.id)[0].aSygn === "brak danych"
            ? el.credit_value
            : data.filter((el2) => el2.id === el.id)[0].aSygn),
        value: el.id,
      });
    });

    return bankOptions;
  };

  return (
    <div className="mainContainerAddClientContact">
      {loading ? (
        <LoadingPopup id="popUpLoading" />
      ) : (
        <>
          <div className="closeBox">
            <button className="closeClientButton" onClick={props.close}>
              X
            </button>
          </div>

          <div id="addPaymentIC" className="inputContainer">
            {props.mode === "main" ? (
              <>
                <div className="inputBox">
                  <div className="inputCol_1">
                    <label>
                      Klient <span className="requiredStar">*</span>
                    </label>
                    <Select
                      noOptionsMessage={() => "Brak danych"}
                      placeholder={"Wybierz..."}
                      isClearable={false}
                      options={clientsOptions}
                      onChange={handleClientChange}
                    />
                  </div>
                </div>
              </>
            ) : (
              ""
            )}

            <div className="inputBox">
              <div className="inputCol_1">
                <label>
                  Rodzaj kontaktu <span className="requiredStar">*</span>
                </label>
                <select
                  type="text"
                  id="court"
                  name="court"
                  value={type}
                  onChange={handleTypeChange}
                >
                  {!type ? (
                    <option key={0} value="0">
                      Wybierz...
                    </option>
                  ) : (
                    ""
                  )}
                  <option key={"Telefoniczny"} value={"Telefoniczny"}>
                    {"Telefoniczny"}
                  </option>
                  <option key={"Mailowy"} value={"Mailowy"}>
                    {"Mailowy"}
                  </option>
                  <option key={"Osobiście"} value={"Osobiście"}>
                    {"Osobiście"}
                  </option>
                </select>
              </div>
            </div>
            <div className="inputBox">
              <div className="inputCol_1">
                <label>Treść kontaktu z klientem</label>
                <textarea
                  spellCheck="false"
                  className="textAreaNote"
                  type="text"
                  id="url"
                  name="url"
                  value={content}
                  onChange={handleContentChange}
                />
              </div>
            </div>

            <div className="saveBoxAP">
              <button className="paymentMenuButton" onClick={addClientContact}>
                zapisz
              </button>
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default AddClientContact;
